import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext.tsx';

const DEFAULT_TITLE = 'Admin Panel';
// Suncrop's logo: used whenever there is no project logo to show.
const DEFAULT_ICON = `${process.env.PUBLIC_URL || ''}/suncrop-logo.png`;

/** Point the browser tab's icon at `href`. */
const setIcon = (href: string) => {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  if (link.getAttribute('href') !== href) link.href = href;
};

/**
 * Makes the browser tab carry the project's name and logo for a project
 * admin, as the sidebar already does. A super admin works across every
 * project, so keeps the plain "Admin Panel" title and icon; so does the
 * sign-in page, where the project is not known yet.
 */
export const Branding = () => {
  const { user, project } = useAuth();
  const branded = user?.role === 'admin' && !!project;
  const name = branded ? project?.name : '';
  const logo = branded ? project?.logo : '';

  useEffect(() => {
    document.title = name ? `${name} · ${DEFAULT_TITLE}` : DEFAULT_TITLE;
  }, [name]);

  useEffect(() => {
    setIcon(logo ? `${logo}` : DEFAULT_ICON);
  }, [logo]);

  return null;
};
